import { performStringComparison } from '../utils';
import { SitecoreIds } from 'lib/constants';
import { RuleContext } from '../rules';
import { WhenCondition } from '../conditions';
import { RuleConditionData } from '../serialization';

export const GeoLocationStateConditionId =
  SitecoreIds.Settings.Rules.Definitions.Elements.EW_Geolocation.State.ItemId;

export class GeoLocationStateCondition<T extends RuleContext> extends WhenCondition<T> {
  value: string;
  operatorid: string;
  constructor(condition: RuleConditionData) {
    super();
    this.value = condition.value as string;
    this.operatorid = condition.operatorid as string;
  }

  execute(ruleContext: T): boolean {
    // Casting to any because the field name is dynamic
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const stateOrProvicnce = ruleContext.parameters['geoLocation.stateOrProvicnce'] as any;

    if (!stateOrProvicnce) {
      return false;
    }

    return performStringComparison(stateOrProvicnce, this.operatorid, this.value);
  }
}
